import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from './paths';
import { mediaPlansRoutes, ordersRoutes, servicesSharedRoutes } from './shared';
import { PageRoute } from './types';

export const backofficeRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/StatisticsPage')),
    path: `${ROUTES.AUTHORIZED.STATISTICS}/:id?`,
    title: 'Statistics',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/MockStatisticsPage')),
    path: ROUTES.AUTHORIZED.STATISTICS_MOCK,
    title: 'Statistics (Mock)',
  },
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServiceSuppliers')),
    path: ROUTES.AUTHORIZED.SERVICE_SUPPLIERS,
    title: 'Service Suppliers',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/SettingsPage')),
    path: ROUTES.AUTHORIZED.ADMIN_SETTINGS,
    title: 'Settings',
  },
  {
    component: asyncComponentLoader(() => import('@/features/users/pages/UserFormPage')),
    path: `${ROUTES.AUTHORIZED.ADMIN_USERS}/edit/:id?`,
    title: 'Users',
  },
  {
    component: asyncComponentLoader(() => import('@/features/users/pages/UsersPage')),
    path: `${ROUTES.AUTHORIZED.ADMIN_USERS}/:tab?`,
    title: 'Users',
  },
  {
    component: asyncComponentLoader(() => import('@/features/users/pages/UserDeletePage')),
    path: `${ROUTES.AUTHORIZED.DELETE_ADMIN_USERS}/:id`,
    title: 'Users',
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/SignupRequestsPage')),
    path: ROUTES.AUTHORIZED.ADMIN_SIGNUP_REQUESTS,
    title: 'Signup Requests',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/SignupRequestDetailsPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADMIN_SIGNUP_REQUESTS}/:id`,
    title: 'Company details',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/company/pages/ApprovedSignupRequestPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADMIN_SIGNUP_REQUESTS}/approved`,
    title: 'Signup request approved',
  },
  {
    component: asyncComponentLoader(() => import('@/features/company/pages/DenySignupRequestPage')),
    path: `${ROUTES.AUTHORIZED.ADMIN_SIGNUP_REQUESTS}/reject/:id`,
    title: 'Deny signup request',
  },
  {
    component: asyncComponentLoader(() => import('@/features/services/pages/ServicesPage')),
    path: ROUTES.AUTHORIZED.ADMIN_SERVICES,
    title: 'Services',
  },
  ...servicesSharedRoutes,
  ...mediaPlansRoutes,
  ...ordersRoutes,
  {
    component: asyncComponentLoader(
      () => import('@/features/service-tasks/pages/ServiceTasksBoardPage'),
    ),
    path: ROUTES.AUTHORIZED.SERVICE_ORDERS,
    title: 'Tasks',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/spaces/pages/AdvertisingSpaceFormPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_SPACE_FORM}/:id?`,
    title: 'Add New Advertising Space',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/spaces/pages/AdvertisingSpaceRemovePage'),
    ),
    path: `${ROUTES.AUTHORIZED.DELETE_ADVERTISING_SPACE}/:id`,
    title: 'Remove Advertising Space',
  },
];
